import React, { useEffect, useState } from "react";
import { Button, Modal, RadioButtonGroup, SelectInput, } from "unified-ui-components-library";
import "./PersonalDetails.css";
import CustomInput from "../../FormComponents/CustomInput/CustomInput";
import { healthDeclarationIcn, nomineeIcn, shieldIcn, unionIcn } from "../../../images/TeleBindingImages/TeleBindingImages";
import { ACCOUNT_TYPE_OPTIONS, CAPS_Y, DECLRATION_IDS, ROUTES, TELEBINDING_WAITING_STAGES } from "../../../utils/constants";
import AxiosRequest from "../../../utils/axios";
import { getApiData } from "../../../api/api";
import IfscDetails from "../IfscDetails/IfscDetails";
import DotsLoader from "../../Loader/DotsLoader/DotsLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import BankDetailsForm from "./BankDetailsForm";
import { getRedirectionRouteForPosv } from "../../../utils/handleProgress";

const axios = new AxiosRequest().getClient();

const PersonalDetails = () => {
  const router = useHistory();
  const [loading, setLoading] = useState(false)
  const [accountNumber, setAccountNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountType, setAccountType] = useState("");
  const [openingDate, setOpeningDate] = useState(null);
  const [dateValue, setDateValue] = useState("");
  const [healthDeclaration, setHealthDeclaration] = useState("")
  const [healthCheck, setHealthCheck] = useState("");

  const [nomineeAccountNumber, setNomineeAccountNumber] = useState("");
  const [nomineeFullName, setNomineeFullName] = useState("");
  const [nomineeIfscCode, setNomineeIfscCode] = useState("");
  const [nomineeAccountType, setNomineeAccountType] = useState("");
  const [nomineeDateValue, setNomineeDateValue] = useState("");
  const [nomineeFetchedDetails, setNomineeFetchedDetails] = useState(null);

  const [isPennyDropLoading, setIsPennyDropLoading] = useState(false);

  const [showPennyPopup, setShowPennyPopup] = useState(false);
  const [pennyDropResult, setPennyDropResult] = useState("");
  const [currentStage, setCurrentStage] = useState("");
  const isNonCasaCase = sessionStorage.getItem("isNonCasaCase");

  // const [fetchedDetails, setFetchedDetails] = useState({
  //   micr: "",
  //   bankName: "",
  //   branchName: "",
  // });
  const [fetchedDetails, setFetchedDetails] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState("");

  const [proposerIfscError, setProposerIfscError] = useState("");
  const [nomineeIfscError, setNomineeIfscError] = useState("");

  const [pennyDropStatus, setPennyDropStatus] = useState(null);
  const [showPennyDropPopup, setShowPennyDropPopup] = useState(false);

  const isPhoneBanking = sessionStorage.getItem('isPhoneBanking') === CAPS_Y


  useEffect(() => {
    const accountHolderName = localStorage.getItem("accountHolderName")
    setFullName(accountHolderName)
    getHealthDeclaration()
  }, []);

  const getHealthDeclaration = async () => {
    const { url, body } = getApiData("getDbStatusEndPoint")
    body.request.payload.declarationids = [DECLRATION_IDS.TELEBINDING_HEALTH]
    body.request.payload.lang = "English"
    body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber")
    
    try {
      setLoading(true)
      const response = await axios.post(url, body)
      console.log({ response })
      if(response?.data?.response?.msgInfo?.msgCode) {
        const declaration = response.data.response.payload.declarations.dec01Teleb.English
        setHealthDeclaration(declaration)
      } else {
        console.log("HEALTH DEC ERR")
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const getHealthDeclarationUI = () => {
    const healthDec = healthDeclaration.split("^^^")
    const mainHeading = healthDec[0]
    const declarationText = healthDec.slice(1, healthDec.length - 1)
    const note = healthDec.slice(healthDec.length - 1)

    return (
      <div className="healthDeclarationContent">

        <p className="healthMainHeading">{mainHeading}</p>

        <ul className="healthDeclarationList">
        {declarationText.map((text, index) => (
          <li key={index} className="healthDeclarationListItem">
            {text}
          </li>
        ))}
      </ul>

        <p className="healthDeclarationNote">{note}</p>
      </div>
    )
  }

  const runPennyDrop = async (userType, accNum, holderName, ifsc) => {
    if (!accNum || !holderName || ifsc.length !== 11) return;

    try {
      setIsPennyDropLoading(true);
      setLoading(true);
      const { url, body } = getApiData("pennydropservice");

      body.request.payload.accountNumber = accNum;
      body.request.payload.accountHolderName = holderName;
      body.request.payload.ifsc = ifsc;
      body.request.payload.policyNumber = localStorage.getItem("policyNumber");
      body.request.payload.pennyDropUserType = userType;

      const response = await axios.post(url, body)

      console.log("Penny Drop Response:", response);

      const msgCode = response.data?.response?.msgInfo?.msgCode;
      const msgDescription = response.data?.response?.msgInfo?.msgDescription;

      if (msgCode === '200') {
        const pennyDropVerification = response.data?.response?.payload?.pennyDropVerification
        const pennyDropNameMatch = response.data?.response?.payload?.pennyDropNameMatch
        if (pennyDropVerification === "Verified") {
          setPennyDropResult({
            status: "success",
            title: "Account verified",
            message:
              "Uploading cancelled cheque is not required.\nDo not edit the bank account details for availing the benefit.",
          });
        } else if(pennyDropVerification === "Not_Verified" && pennyDropNameMatch === "Not_Verified") {
          setPennyDropResult({
            status: "error",
            title: "Invalid Bank Details",
            message: "Account Holder name does not match with Bank Records.",
          });
        } else if(pennyDropVerification === "Not_Verified" && !pennyDropNameMatch) {
          setPennyDropResult({
            status: "error",
            title: "Invalid Bank Details",
            message: "Please provide valid/active bank account details.",
          });
        } else {
          setPennyDropResult({
            status: "error",
            title: "",
            message: "Internal server error or API Down.",
          });
        }
      } else {
        setPennyDropResult({
          status: "error",
          title: "",
          message: "Internal server error or API Down.",
        });
      }
      setShowPennyPopup(true);
    } catch (error) {
      console.error("Penny Drop Error:", error);
      setPennyDropResult({
        status: "error",
        title: "",
        message: `Internal server error or API Down.`,
      });
      setShowPennyPopup(true);
    } finally {
      setIsPennyDropLoading(false);
      setLoading(false);
    }
  };


  useEffect(() => {
    const isValid = accountNumber && fullName && ifscCode.length === 11;
    if (!isValid) return;

    const timeout = setTimeout(() => {
      runPennyDrop("Proposer", accountNumber, fullName, ifscCode);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [accountNumber, fullName, ifscCode]);


  useEffect(() => {
    const isValid = nomineeAccountNumber && nomineeFullName && nomineeIfscCode.length === 11;
    if (!isValid) return;

    const timeout = setTimeout(() => {
      runPennyDrop("Nominee", nomineeAccountNumber, nomineeFullName, nomineeIfscCode);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [nomineeAccountNumber, nomineeFullName, nomineeIfscCode]);



  const isProposerValid = () => {
    console.log({
      accountNumber: accountNumber.trim() !== "" ,
      fullName: fullName.trim() !== "" ,
      ifscCode: ifscCode.trim().length === 11 ,
      bankName: fetchedDetails?.bankName ,
      branchName: fetchedDetails?.branchName ,
      micr: fetchedDetails?.micr ,
      accountType: accountType !== "" ,
      dateValue: dateValue !== "" ,
      isPhoneBanking
    })
    return (
      accountNumber.trim() !== "" &&
      fullName.trim() !== "" &&
      ifscCode.trim().length === 11 &&
      fetchedDetails?.bankName &&
      fetchedDetails?.branchName &&
      fetchedDetails?.micr &&
      accountType !== "" &&
      dateValue !== "" &&
      (isPhoneBanking ? true : healthCheck !== "")
    );
  };

  const isNomineeAnyFieldFilled = () => {
    return (
      nomineeAccountNumber.trim() !== "" ||
      nomineeFullName.trim() !== "" ||
      nomineeIfscCode.trim() !== "" ||
      nomineeAccountType !== "" ||
      nomineeDateValue !== ""
    );
  };

  const isNomineeValid = () => {
    if (!isNomineeAnyFieldFilled()) return true;
    return (
      nomineeAccountNumber.trim() !== "" &&
      nomineeFullName.trim() !== "" &&
      nomineeIfscCode.trim().length === 11 &&
      nomineeFetchedDetails?.bankName &&
      nomineeFetchedDetails?.branchName &&
      nomineeFetchedDetails?.micr &&
      nomineeAccountType !== "" &&
      nomineeDateValue !== ""
    );
  };

  const isFormValid = () => {
    if(isPhoneBanking) {
      return isProposerValid()
    }
    if(isNonCasaCase === "N") {
      return isNomineeValid() && (isPhoneBanking ? true : healthCheck !== "");
    }
    return isProposerValid() && isNomineeValid();
  };

  const handleSubmit = async () => {
    setIsSaving(true);
    setSaveError("");

    try {
      const { url, body } = getApiData("tbpiisave");
      body.request.payload.transactionId = sessionStorage.getItem("posvRefNumber");

      body.request.payload.proposalBankDetails = [
        {
          bankAccountNumber: accountNumber,
          accountHolderName: fullName,
          micr: fetchedDetails?.micr || "",
          ifsc: ifscCode,
          bankName: fetchedDetails?.bankName || "",
          bankBranch: fetchedDetails?.branchName || "",
          typeOfAccount: accountType?.label,
          bankAccOpeningDate: dateValue
        },
      ];

      body.request.payload.nomineeBankDetails = nomineeAccountNumber
        ? [
          {
            bankAccountNumber: nomineeAccountNumber,
            accountHolderName: nomineeFullName,
            micr: nomineeFetchedDetails?.micr || "",
            ifsc: nomineeIfscCode,
            bankName: nomineeFetchedDetails?.bankName || "",
            bankBranch: nomineeFetchedDetails?.branchName || "",
            typeOfAccount: nomineeAccountType?.label,
            bankAccOpeningDate: nomineeDateValue
              ? new Date(nomineeDateValue).toISOString()
              : null,
          },
        ]
        : [];

      body.request.payload.isHealthDeclared = healthCheck;

      const response = await axios.post(url, body);
      const payload = response.data?.response?.payload;
      const msgCode = response.data?.response?.msgInfo?.msgCode;
      const businessMsg = response.data?.response?.payload?.businessMsg

      console.log("payload", payload)
      console.log("PII Save Response:", response);

      
      if (msgCode === "200") {

        if (healthCheck === "N" && !isPhoneBanking) {
          router.push(ROUTES.NOT_DECLARATION);

        } else {
          sessionStorage.setItem("tbStageOnOtp", response?.data?.response?.payload?.teleBStage);
          router.push(ROUTES.WAITING);
        }
        
      } else {
        setSaveError(businessMsg);
      }
    } catch (error) {
      console.error("PII Save Error:", error);
      setSaveError("Something went wrong. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  // const handleSubmit = (e) => {
  //    router.push(ROUTES.PAYMENT);
  // }

  if(loading) {
    return <DotsLoader msg={"Please wait..."} />
  }

  return (

    <>
      <>
        {showPennyPopup && pennyDropResult && (
          <Modal
            isOpen={showPennyPopup}
            onClose={() => setShowPennyPopup(false)}
            title={pennyDropResult.title}
            size="m"
            closeButton
          >
            <div className="pennyDropModal">
              <p
                className={
                  pennyDropResult.status === "success"
                    ? "pennyDropTitle success"
                    : "pennyDropTitle error"
                }
              >
                {pennyDropResult.title}
              </p>
              <p className="pennyDropMessage">{pennyDropResult.message}</p>

              <div className="pennyDropActions">
                <Button onClick={() => setShowPennyPopup(false)}>
                  {pennyDropResult.status === "success" ? "OK" : "Edit Details"}
                </Button>
              </div>
            </div>
          </Modal>
        )}
      </>
      <div className="personal-details">
        <div className="detailsWrapper">
          <div className="headingWrapper">
            <span>STEP 1</span>
            <div className="subHeadingWrapper">
              <h4>Personal Details</h4>
              <p>
                Please enter your Bank details, Nominee details and acknowledge a simple health declaration
              </p>
            </div>
          </div>

         {isNonCasaCase === "Y" && <div className="bankDetailsCard">
            <span id="circularImg">
              <img src={unionIcn} alt="bank" className="union-img" />
            </span>

            <div className="bankDetailsHeading">
              <h4>Proposer's Bank Details</h4>
              <p>
                All payouts will be credited to this account through electronic payment
              </p>
            </div>

            <BankDetailsForm
              accountNumber={accountNumber}
              setAccountNumber={setAccountNumber}
              accountType={accountType}
              setAccountType={setAccountType}
              dateValue={dateValue}
              setDateValue={setDateValue}
              fetchedDetails={fetchedDetails}
              setFetchedDetails={setFetchedDetails}
              fullName={fullName}
              setFullName={setFullName}
              ifscCode={ifscCode}
              setIfscCode={setIfscCode}
              ifscError={proposerIfscError}
              setIfscError={setProposerIfscError}
              userType={"proposer"}
            />

          </div>}

          {!isPhoneBanking && <div className="bankDetailsCard">
            <span id="circularImg">
              <img src={nomineeIcn} alt="nominee" className="union-img" />
            </span>

            <div className="bankDetailsHeading">
              <h4>Nominee Bank Details(Optional)</h4>
              <p>
                Please specify Bank Details regarding the nominee. Only single nominee
                can be added.
              </p>
            </div>

            <BankDetailsForm
              accountNumber={nomineeAccountNumber}
              setAccountNumber={setNomineeAccountNumber}
              accountType={nomineeAccountType}
              setAccountType={setNomineeAccountType}
              dateValue={nomineeDateValue}
              setDateValue={setNomineeDateValue}
              fetchedDetails={nomineeFetchedDetails}
              setFetchedDetails={setNomineeFetchedDetails}
              fullName={nomineeFullName}
              setFullName={setNomineeFullName}
              ifscCode={nomineeIfscCode}
              setIfscCode={setNomineeIfscCode}
              ifscError={nomineeIfscError}
              setIfscError={setNomineeIfscError}
            />
          </div>}

          {!isPhoneBanking && <div className="bankDetailsCard">
            <span id="circularImg">
              <img src={healthDeclarationIcn} alt="health" className="union-img" />
            </span>

            <div className="bankDetailsHeading">
              <h4>Health Declaration</h4>
              <p>
                Require a confirmation of proposer's overall health status
              </p>
            </div>

            <div className="healthDeclaration">

              <div className="DeclarationContent">
                {healthDeclaration && getHealthDeclarationUI()}
              </div>

              <div className="healthOptions">
                <RadioButtonGroup
                  className="healthOptions small"
                  options={[
                    { label: "Yes, I agree", value: "Y" },
                    { label: "No, I don't agree", value: "N" },
                  ]}
                  selectedValue={healthCheck}
                  onChange={(val) => setHealthCheck(val)}
                  stacking="horizontal"
                />
              </div>
            </div>
          </div>}
        </div>

        <div className="buttonWrapper">
          <Button
            width="364"
            disabled={!isFormValid()}
            onClick={handleSubmit}
          >
            Submit and Proceed
          </Button>
        </div>
      </div>
    </>
  );
};

export default PersonalDetails;
